export default __webpack_public_path__ + "static/media/right_arrow.ef0802b4.svg";